<template>
  <page-wrap>
    <vehicle-manage-panel source="hik" :use-hik-api="true" :readonly="false" />
  </page-wrap>
</template>

<script>
import PageWrap from '../components/PageWrap'
import VehicleManagePanel from '../components/VehicleManagePanel'

export default {
  name: 'CheliangHikManage',
  components: { PageWrap, VehicleManagePanel }
}
</script>
